import { stringsEqualIgnoreCase } from "../../util";

/**
 * Revision History
 * 
 * 211124 ptkim     Create
 */
export class SQLField {
  fieldName: string = '';
  propertyName: string = '';
  value: any = undefined;

  constructor(init?: Partial<SQLField>) {
    Object.assign(this, init);
  }

}

export enum SQLType {
  Select,
  Insert,
  Update,
  Delete,
  InsertOrUpdate,
  Execute
}

export enum SQLCondition {
  And,
  Or
}

export class SQLInfo {
  tableName: string = '';
  type: SQLType = SQLType.Select;
  isSingleTable: boolean = true;
  fields: SQLField[] = [];
  key: SQLField|null = null;
  whereFields: SQLField[] = [];
  where: string = '';
  conditionalString: string = '';

  // TableName for SQLType.Execute
  static BlStatus = "BlStatus";
  static UpdateDutyEntity = "UpdateDutyEntity";
  static UpdateSrcDutyEntity = "UpdateSrcDutyEntity";
  static UpdateBrokerInfo = "UpdateBrokerInfo";
  static UpdateStatusOP = "UpdateStatusOP";
  static SaveAcctHistory = "SaveAcctHistory";
  static UpdateOriginActionDate = "UpdateOriginActionDate";
  static DeleteDepoData = "DeleteDepoData";
  static DeleteApData = "DeleteApData";
  static UpdateHblITInfo = "UpdateHblITInfo";
  static UpdateHblFDest = "UpdateHblFDest";
  static SaveAiManifest = "SaveAiManifest";
  static UpdateWhLocationStatus = "UpdateWhLocStatus";
  static RegisterWhItem = "RegisterWhItem";
  static UpdateByAcmeID = "UpdateByAcmeID";
  static UpdateHistory = "UpdateHistory";

  static UpdateVoidInfo = "UpdateVoidInfo";
  static UpdateCreditInfo = "UpdateCreditInfo";
  static UpdateCancelCreditInfo = "UpdateCancelCreditInfo";
  static UpdateBLInfo = "UpdateBLInfo";
  static SaveReviseInvo = "SaveReviseInvo";
  static UpdatePaidAmend = "UpdatePaidAmend";

  // Exec SP
  static SaveNewJournalByMaster = "dbo.up_SaveNewJournalByMaster @TBName, @TBId, @LoginId";
  static MatchAdvanceInPayment = "dbo.up_MatchAdvanceAcctCode @TBName, @TBId, @NewDate, @GlNo, @LoginID";
  static SaveNewJournalByTask = "dbo.up_SaveNewJournalByTask @TBName, @TBId, @LoginId, @SeqNo";

  constructor(init?:Partial<SQLInfo>) {
    Object.assign(this, init);
  }

  static getWhereFieldValue(sqlInfo:SQLInfo, propName:string): any{
    const sf = sqlInfo.whereFields.find(x=> stringsEqualIgnoreCase(x.propertyName, propName))
    return sf ? sf.value : undefined;
  }

  static getFieldValue(sqlInfo:SQLInfo, propName:string): any{
    const sf = sqlInfo.fields.find(x=> stringsEqualIgnoreCase(x.propertyName, propName))
    return sf ? sf.value : undefined;
  }

  static getFieldByPropertyName(sqlInfo:SQLInfo, propName:string): SQLField|undefined {
    return sqlInfo.fields.find(x => stringsEqualIgnoreCase(x.propertyName, propName))
  }

  static getFieldByFieldName(sqlInfo:SQLInfo, fldName:string): SQLField|undefined {
    return sqlInfo.fields.find(x => stringsEqualIgnoreCase(x.fieldName, fldName))
  }

  static hasFieldOfPropertyWithValue(sqlInfo:SQLInfo, propName:string, value:any):boolean{
    const sf = this.getFieldByPropertyName(sqlInfo, propName);
    if(!sf) return false;
    return sf.value === value;
  }

  static hasWhereFieldOfPropertyWithValue(sqlInfo:SQLInfo, propName:string, value:any):boolean{
    const sf = this.getWhereFieldByPropertyName(sqlInfo, propName);
    if(!sf) return false;
    return sf.value === value;
  }

  static setFieldValueByPropertyName(sqlInfo:SQLInfo, propName:string, value:any){
    const sf = this.getWhereFieldByPropertyName(sqlInfo, propName);
    if(sf) sf.value = value;
  }

  static getWhereFieldByPropertyName(sqlInfo:SQLInfo, propName:string): SQLField|undefined{
    return sqlInfo.whereFields.find(x => stringsEqualIgnoreCase(x.propertyName, propName));
  }

  static getWhereFieldByFieldName(sqlInfo:SQLInfo, fldName:string): SQLField|undefined {
    return sqlInfo.whereFields.find(x => stringsEqualIgnoreCase(x.fieldName, fldName))
  }

  static setWhereFieldValueByPropertyName(sqlInfo:SQLInfo, propName:string, value:any){
    const sf = this.getWhereFieldByPropertyName(sqlInfo, propName);
    if(sf) sf.value = value;
  }

  static setWhereFieldValueByFieldName(sqlInfo:SQLInfo, fldName: string, value:any): void {
    const sf = this.getWhereFieldByFieldName(sqlInfo, fldName);
    if(sf) sf.value = value;
  }
}